import { RunConfig, RUNS, type RunDifficulty } from '../../config/runs'

const DIFFICULTY_COLORS: Record<RunDifficulty, string> = {
  green: '#22c55e',
  blue: '#3b82f6',
  black: '#111111',
  doubleBlack: '#111111',
}

const DIFFICULTY_LABELS: Record<RunDifficulty, string> = {
  green: '●',
  blue: '■',
  black: '◆',
  doubleBlack: '◆◆',
}

export class GameHUD {
  private container: HTMLDivElement
  private speedEl: HTMLDivElement
  private runNameEl: HTMLDivElement
  private controlsEl: HTMLDivElement
  private runSelectEl: HTMLDivElement

  constructor(config: RunConfig) {
    this.container = document.createElement('div')
    this.container.style.cssText = `
      position: fixed; top: 0; left: 0; width: 100%; height: 100%;
      pointer-events: none; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    `

    // Speed display (top-left)
    this.speedEl = document.createElement('div')
    this.speedEl.style.cssText = `
      position: absolute; top: 20px; left: 20px;
      font-size: 28px; font-weight: 700; color: white;
      text-shadow: 0 2px 8px rgba(0,0,0,0.5);
    `
    this.container.appendChild(this.speedEl)

    // Run name (top-right)
    const diffColor = DIFFICULTY_COLORS[config.difficulty]
    const diffLabel = DIFFICULTY_LABELS[config.difficulty]
    this.runNameEl = document.createElement('div')
    this.runNameEl.style.cssText = `
      position: absolute; top: 20px; right: 20px;
      font-size: 18px; font-weight: 600; color: white;
      text-shadow: 0 2px 8px rgba(0,0,0,0.5);
    `
    this.runNameEl.innerHTML = `<span style="color:${diffColor}">${diffLabel}</span> ${config.name}`
    this.container.appendChild(this.runNameEl)

    // Run selector (top-right, below run name)
    this.runSelectEl = document.createElement('div')
    this.runSelectEl.style.cssText = `
      position: absolute; top: 52px; right: 20px;
      font-size: 12px; color: rgba(255,255,255,0.7); background: rgba(0,0,0,0.3);
      padding: 6px 12px; border-radius: 6px; pointer-events: auto; cursor: pointer;
      backdrop-filter: blur(4px);
    `
    this.runSelectEl.innerHTML = this.buildRunList()
    this.container.appendChild(this.runSelectEl)

    // Controls hint (bottom-center)
    this.controlsEl = document.createElement('div')
    this.controlsEl.style.cssText = `
      position: absolute; bottom: 24px; left: 50%; transform: translateX(-50%);
      font-size: 13px; color: rgba(255,255,255,0.8); background: rgba(0,0,0,0.35);
      padding: 8px 16px; border-radius: 8px; backdrop-filter: blur(4px);
      text-align: center;
    `
    this.controlsEl.innerHTML = `
      <b>A/D</b> or <b>←/→</b> Steer &nbsp;·&nbsp;
      <b>W/↑</b> Tuck &nbsp;·&nbsp;
      <b>S/↓</b> Brake &nbsp;·&nbsp;
      <b>Space</b> Hop
    `
    this.container.appendChild(this.controlsEl)

    document.body.appendChild(this.container)
  }

  private buildRunList(): string {
    const currentHash = window.location.hash.slice(1)
    let html = '<b>Switch run:</b><br>'
    for (const [id, run] of Object.entries(RUNS)) {
      const color = DIFFICULTY_COLORS[run.difficulty]
      const label = DIFFICULTY_LABELS[run.difficulty]
      const active = id === currentHash || (!currentHash && id === 'patsys')
      const style = active ? 'font-weight:700;' : ''
      html += `<a href="#${id}" style="color:white;text-decoration:none;${style}" onclick="event.preventDefault();window.location.hash='${id}';window.location.reload()"><span style="color:${color}">${label}</span> ${run.name}</a><br>`
    }
    return html
  }

  updateSpeed(speedMph: number): void {
    this.speedEl.textContent = `${Math.round(speedMph)} mph`
  }
}
